// extracted by mini-css-extract-plugin
export default {"trigger":"trigger-F8cHM","popover":"popover-kz5GH"};